'use client'

import { cn } from '@/lib/utils'
import { useChatStore } from '@/store/chat.store'
import { Headset, Loader2 } from 'lucide-react'
import { useTranslations } from 'next-intl'

export default function LiveSupportBanner() {
  const t = useTranslations('liveSupportBanner')
  const tCommon = useTranslations('common')
  const operatorName = useChatStore(state => state.operatorName)
  const liveSupportState = useChatStore(state => state.liveSupportState)

  const isInQueue = liveSupportState?.in_queue && liveSupportState?.status === 'pending'
  const isProcessing = liveSupportState?.in_queue && liveSupportState?.status === 'processing'
  const isLiveSupport = isInQueue || isProcessing || !!operatorName

  const name = operatorName || tCommon('operator')

  const subtitle = isInQueue
    ? liveSupportState?.queue_position
      ? t('waitingOperatorWithPosition', { position: liveSupportState.queue_position })
      : t('waitingOperator')
    : isProcessing && !operatorName
      ? t('connecting')
      : isLiveSupport
        ? tCommon('liveSupport')
        : tCommon('online')

  return (
    <div className='flex min-w-0 items-center gap-3'>
      <div className='flex size-10 shrink-0 items-center justify-center rounded-full bg-[var(--widget-header-foreground)] text-[var(--widget-header)] shadow-sm'>
        <Headset className='size-5' />
      </div>
      <div className='flex min-w-0 flex-col gap-1'>
        <span className='truncate text-[15px] leading-tight font-bold tracking-tight'>{name}</span>
        <span className='flex items-center gap-1.5 text-xs leading-tight text-[var(--widget-header-foreground)] opacity-90'>
          {isInQueue ? (
            <Loader2 className='size-3 shrink-0 animate-spin' />
          ) : (
            <span
              className={cn(
                'size-2 shrink-0 rounded-full',
                isProcessing && !operatorName ? 'bg-amber-400' : 'bg-[#22c55e]'
              )}
            />
          )}
          <span className='truncate'>{subtitle}</span>
        </span>
      </div>
    </div>
  )
}
